
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("gvfIi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
// ====================================================================================
// twingle.module
// ====================================================================================
var $c03bbaf8fbb54e98$var$init = module.exports.init = function init() {
    var attempts = 0;
    // if document.ready needed
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") window.addEventListener("message", function(event) {
            if (event && event.data && event.data.type === "donationFinished") {
                console.log(event.data);
                dataLayer.push({
                    "event": "add_payment_info",
                    "ecommerce": {
                        "currency": "EUR",
                        "payment_type": event.data.value.paymentMethod,
                        "value": event.data.value.amount,
                        "tax": 0,
                        "items": [
                            {
                                price: event.data.value.amount,
                                item_id: event.data.value.target,
                                item_variant: event.data.value.rythm,
                                item_category: "Spende",
                                item_category2: "Twingle",
                                quantity: 1
                            }
                        ]
                    }
                });
                dataLayer.push({
                    "event": "purchase",
                    "ecommerce": {
                        "currency": "EUR",
                        "value": event.data.value.amount,
                        "tax": 0,
                        "items": [
                            {
                                price: event.data.value.amount,
                                item_variant: event.data.value.rythm,
                                item_id: event.data.value.target,
                                item_category: "Spende",
                                item_category2: "Twingle",
                                quantity: 1
                            }
                        ]
                    }
                });
            }
        }, false);
        else setTimeout(function() {
            _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=twingle.module.0c2c2921.js.map
